import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
} from '@backstage/theme';


export const myTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.light,
            primary: {
                main: '#FFD400', // Amarillo Leal para la AppBar
            },
            secondary: {
                main: '#000000', // Negro de apoyo
            },
            background: {
                default: '#f5f5f5',
                paper: '#ffffff',
            },
            navigation: {
                background: '#000000', // Sidebar en negro
                indicator: '#FFD400',  // Indicador amarillo
                color: '#FFFFFF',      // Iconos/textos en blanco
                selectedColor: '#FFD400', // Texto/icono activo en amarillo
            },
            typography: {
                h1: { color: '#000000' },
                subtitle1: { color: '#000000' },
            }
        },
    }),
    defaultPageTheme: 'home',
    //   fontFamily: 'Comic Sans MS',
    /* below drives the header colors */
    pageTheme: {
        home: genPageTheme({ colors: ['#FFD400', '#FFD400'], shape: shapes.wave }),
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#000000', // Enlaces (ej. títulos de APIs y Components) en negro
                    textDecoration: 'none',
                    '&:hover': {
                        color: '#000000', // opcional: hover en amarillo
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    '& a': {
                        color: '#000000', // asegura que <a> dentro de Typography sean negros
                        textDecoration: 'none',
                    },
                },
            },
        },
    },
});